import * as Yup from "yup";

export const BlogsValidationSchema = Yup.object().shape({
  formType: Yup.string().required(),
  displayTitle: Yup.string().required(),
});
